<template>
  <!-- 取消訂單視窗 -->
  <ui-modal ref="cancelOrderModal" content-class="cancel-order-dialog" :forcing="true" :header-title="$t('cancel_order_title')" :hide-overlay="false">
    <v-sheet class="cancel-order-container">
      <p class="mb-0 wd-whitespace-pre-line">{{ cancelHintText }}</p>
    </v-sheet>

    <template #buttons>
      <div class="event-buttons-group">
        <v-btn v-if="allowCancelOrder" class="cancel-btn large--btn mr-4" min-width="32" height="40" color="gray20" elevation="0" @click="hideModal">
          {{ $t('cancel_booking_consider_button') }}
        </v-btn>

        <v-btn
          v-if="allowCancelOrder"
          class="confirm-btn large--btn"
          :loading="isLoading"
          min-width="32"
          height="40"
          color="orange50"
          elevation="0"
          @click="confirmCancelOrder"
        >
          {{ $t('booking_detail_cancel') }}
        </v-btn>
        <v-btn v-else class="confirm-btn large--btn" min-width="32" height="40" color="orange50" elevation="0" @click="hideModal">
          {{ $t('all_ok') }}
        </v-btn>
      </div>
    </template>
  </ui-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import UiModal from '@/components/dialog/ui-modal.vue'
import * as OrderService from '@/service/order'
import { useAlertStore } from '@/store-pinia/alert'

export default defineComponent({
  name: 'CancelOrderModal',
  components: {
    UiModal,
  },
  props: {
    order: { type: Object, default: () => ({}) },
    orderCancelInfo: { type: Object, default: () => ({}) },
    token: { type: String, default: '' },
  },
  setup() {
    const alertStore = useAlertStore()

    return {
      showAlert: alertStore.showAlert,
    }
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    allowCancelOrder() {
      return this.orderCancelInfo.cancelable
    },
    cancelHintText() {
      return this.orderCancelInfo.cancel_rule
    },
    ...mapGetters({
      fromTngMiniProgram: 'fromTngMiniProgram',
    }),
  },
  methods: {
    resetUserOrder() {
      if (this.fromTngMiniProgram) {
        location.replace(`/en/tng/1?from=tng&type=tng-order-detail&orderid=${this.order.id}`)
      } else {
        window.location.reload()
      }
    },
    confirmCancelOrder() {
      if (this.order.id) {
        this.isLoading = true
        OrderService.cancelOrder(this.$axios, this.order.id, { token: this.token })
          .then(res => {
            if (res.code === 0) {
              this.sendTrackingCode(this.order.id)
              this.resetUserOrder()
            }
            this.isLoading = false
            this.hideModal()
          })
          .catch(error => {
            console.error('confirmCancelOrder:error', error)
            this.showAlert({ type: 'error', message: error.message })
            this.isLoading = false
            this.hideModal()
          })
      }
    },
    showModal() {
      this.$refs.cancelOrderModal.showModal()
    },
    hideModal() {
      this.$refs.cancelOrderModal.hideModal()
    },
    sendTrackingCode(orderID) {
      this.$gtm.push({ ecommerce: null })
      this.$gtm.push({
        event: 'refund',
        ecommerce: {
          refund: {
            actionField: {
              id: orderID,
            },
          },
        },
      })
    },
  },
})
</script>

<style scoped lang="scss">
.cancel-order-container {
  padding: 20px;
  overflow-y: auto;

  .button-group {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
